const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCreditProtection100X100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.81 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Credit-Protection_100x100") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M99.826,149.794l-0.464-.3c-6.768-2.7-40.937-19.636-49.015-88.353L50.1,59l2,0.788a44.727,44.727,0,0,0,23.419,2.556A45.3,45.3,0,0,0,99.131,50.655l0.911-.861,0.887,0.887c6.638,6.638,19.05,10.762,32.392,10.762a61.078,61.078,0,0,0,14.772-1.7l1.812-.453-0.218,1.854c-2.5,21.309-9.333,51.115-27.636,72.107-11.112,12.744-21.2,16.2-21.626,16.346ZM53.164,62.929c8.224,64.626,39.818,81.149,46.875,84.058,2-.791,10.679-4.666,20.068-15.433,17.357-19.907,24.164-48.094,26.8-68.891a65.153,65.153,0,0,1-13.582,1.359c-13.642,0-25.975-3.967-33.32-10.664A47.877,47.877,0,0,1,75.928,64.894,47.224,47.224,0,0,1,53.164,62.929Z",
    transform: "translate(-50.095 -49.794)",
    style: {
      fill: "#2E3135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.632,
    y: 1.798,
    width: 2.579,
    height: 96.779,
    style: {
      fill: "#2E3135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.497,
    y: 57.496,
    width: 2.579,
    height: 22.821,
    transform: "translate(-47.392 93.142) rotate(-55.64)",
    style: {
      fill: "#2E3135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.134,
    y: 50.583,
    width: 2.613,
    height: 51.207,
    transform: "translate(-60.087 83.645) rotate(-55.641)",
    style: {
      fill: "#2E3135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.59,
    y: 69.551,
    width: 2.579,
    height: 45.317,
    transform: "translate(-74.43 88.511) rotate(-55.64)",
    style: {
      fill: "#2E3135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.088,
    y: 88.583,
    width: 2.579,
    height: 38.006,
    transform: "translate(-88.649 92.316) rotate(-55.64)",
    style: {
      fill: "#2E3135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.974,
    y: 108.492,
    width: 2.531,
    height: 27.981,
    transform: "translate(-102.748 95.391) rotate(-55.64)",
    style: {
      fill: "#2E3135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.857,
    y: 129.334,
    width: 2.58,
    height: 14.85,
    transform: "matrix(0.564, -0.826, 0.826, 0.564, -116.753, 97.403)",
    style: {
      fill: "#2E3135"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditProtection100X100);
export default __webpack_public_path__ + "static/media/Icon-Credit-Protection-100x100.846b001b151659b4942ea25d0af86298.svg";
export { ForwardRef as ReactComponent };